export const profileQueryKeys = {
  profile: ['auth', 'profile'] as const,
};
